module.exports = __webpack_public_path__ + "media/application/images/svgs/icon-plus-134394178f0ea18ed49b58251cdfd668.svg";